import * as Yup from "yup";
import {
  INPUT_LIMIT,
  REGEX_ONLY_NUMBER_AND_HYPHEN,
} from "../../../helpers/constants";
import { specialCharactersNotAllowedValidationForOptionalField, validFieldValidation } from "../../../helpers/constants/commonValidationSchemaUtils";
import { commonSiteCoreKeys } from "../../../helpers/constants/siteCoreKeys";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import {
  ProgramSearchProgramFormKey,
  TransferParticipantFormKey,
  transferTypeKey,
} from "./models";
import { KeyValue } from "../../../helpers/types/common";

export const SearchProgramSchema = (
  fetchValidationMessage: (key: string, replacements?: KeyValueMap) => string,
  commonValidationMessages: KeyValue,
) =>
  Yup.object().shape({
    [ProgramSearchProgramFormKey.searchType]:
      Yup.string().default("individuals"),
    [ProgramSearchProgramFormKey.billingContactLastName]: 
    specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage
      )
      .default(""),
    [ProgramSearchProgramFormKey.billingContactLastNameFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.hrContactLastName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.projectKey]: validFieldValidation(
      fetchValidationMessage(
        commonSiteCoreKeys.alphabetOrSpecialCharNotAllowed,
      ),
      REGEX_ONLY_NUMBER_AND_HYPHEN,
    ).default(""),
    [ProgramSearchProgramFormKey.projectKeyFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.projectName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.projectNameFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.programName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.programNameFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.programStatus]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.programStartMonthAndYear]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.hrContactLastNameFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.projectManager]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.lineOfBusiness]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.solutionCategory]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.clientRelationshipOwner]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantFirstName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.participantFirstNameFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantLastName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.participantLastNameFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.keyNumber]: Yup.string()
      .matches(
        INPUT_LIMIT.NUMERIC_AND_DASH,
        commonValidationMessages.onlyNumericAndHyphenAreAllowed,
      )
      .default(""),
    [ProgramSearchProgramFormKey.keyNumberFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantEmail]:  Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantEmailFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.isPrimaryParticipantEmail]:
      Yup.boolean().default(false),
    [ProgramSearchProgramFormKey.nextParticipantEmail]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.nextParticipantEmailFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.isPrimaryNEXTParticipantEmail]:
      Yup.boolean().default(false),
    [ProgramSearchProgramFormKey.mobileISOCode]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.mobileCountryCode]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantMobileNumber]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.isPrimaryParticipantMobileNumber]:
      Yup.boolean().default(false),
    [ProgramSearchProgramFormKey.clientName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.clientNameFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.clientManagedStatus]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.genericAccountName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.genericAccountNameFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.genericRegistrationCode]: Yup.string()
      .notRequired()
      .default(""),
    [ProgramSearchProgramFormKey.genericRegistrationCodeFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.nextView]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.genericAccountStatus]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.nextProgramClass]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantStatus]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.purpose]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.country]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.deliveryOffice]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.requestedBy]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.nisId]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.nisIdFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.clientEmployer]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.clientEmployerFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.nisStatus]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.hrContact]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProgramSearchProgramFormKey.hrContactFilter]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantEmailPersonal]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.participantEmailPersonalFilter]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.isParticipantEmailPersonal]:
      Yup.boolean().default(false),
    [ProgramSearchProgramFormKey.nisMobileISOCode]: Yup.string().default(""),
    [ProgramSearchProgramFormKey.nisMobileCountryCode]:
      Yup.string().default(""),
    [ProgramSearchProgramFormKey.nisParticipantMobileNumber]:
      Yup.string().default(""),
  });

export const TransferParticipantSchema = (
  fetchValidationMessage: (key: string) => string,
  isCMC: boolean, // Pass isCMC to dynamically change validation
) =>
  Yup.object().shape({
    [TransferParticipantFormKey.destinationCountry]: Yup.string()
      .nullable()
      .optional()
      .when([TransferParticipantFormKey.transferType], {
        is: (transferType: string) =>
          !isCMC || transferType === transferTypeKey.changeCountry, // Always required if !isCMC or changeCountry is selected
        then: (schema) =>
          schema.required(
            fetchValidationMessage(commonSiteCoreKeys.requiredValidation),
          ),
      }),

    [TransferParticipantFormKey.compatibleProgramTemplate]: Yup.string()
      .nullable()
      .optional()
      .when([TransferParticipantFormKey.transferType], {
        is: (transferType: string) =>
          isCMC && transferType === transferTypeKey.changeTransfer, // Required only when changeProgram is selected
        then: (schema) =>
          schema.required(
            fetchValidationMessage(commonSiteCoreKeys.requiredValidation),
          ),
      }),

    [TransferParticipantFormKey.nextLanguage]: Yup.string()
      .nullable()
      .optional()
      .when([TransferParticipantFormKey.transferType], {
        is: (transferType: string) =>
          !isCMC || transferType === transferTypeKey.changeCountry, // Always required if !isCMC or changeCountry is selected
        then: (schema) =>
          schema.required(
            fetchValidationMessage(commonSiteCoreKeys.requiredValidation),
          ),
      }),
  });
